export const GRADIENT_GRAY = "linear-gradient(to left, #fafafaff, #F0F0F0)";

// The primary brand gradient (Origin flipped to bottom-right)
export const GRADIENT_MAIN = 
  "radial-gradient(circle farthest-corner at 90% 80%, #029db5 0%, #02798b 90.2%)";

// A slightly brighter version for hover states (Origin flipped to bottom-right)
export const GRADIENT_HOVER = 
  "radial-gradient(circle farthest-corner at 90% 80%, #03b0cc 0%, #0290a5 90.2%)";

export const COLOR_BLACK = "#000";
export const COLOR_LESS_BLACK = "#15161a";
export const COLOR_WHITE = "#fff";
export const COLOR_LIGHT_GRAY = "#707070";
export const COLOR_VERY_LIGHT_GRAY = GRADIENT_GRAY;
export const COLOR_VERY_LIGHT_GRAY_ = "#F0F0F0";
export const COLOR_SLIGHTLY_DARKER_WHITE = "#FDFDFD";
export const COLOR_GOLD = "#FFD700";
export const COLOR_GREEN = "#56e817";
export const COLOR_RED = "#d41f0e";
export const COLOR_MAIN = "#02798b";
